export class ApmConfig {
  readonly SERVICE_NAME: string = "gloss-client";
  readonly SERVER_URL: string = "https://data.apm.gloss-vault.com";

  private _environment: string;

  private _serviceVersion: string;

  constructor() {
    this.environment = process.env.IS_LOCAL ? "localhost" : process.env.NODE_ENV;
    this.serviceVersion = process.env.APPLICATION_VERSION;
  }

  get environment(): string {
    return this._environment;
  }

  set environment(value: string) {
    this._environment = value;
  }

  get serviceVersion(): string {
    return this._serviceVersion;
  }

  set serviceVersion(value: string) {
    this._serviceVersion = value;
  }
}
